<template>
  <div class="myClass">
    <div class="title">
      <h2>我的班级</h2>
    </div>
    <div class="sea">
      <span>班级列表</span>
      <div class="mod">
        <a-select
          class="selbtn"
          allow-clear
          placeholder="课程名称"
          :notFoundContent="'暂无数据'"
          @change="Select"
          v-decorator="['modelname',{rules:[{required:true,message:'请选择课程名称'}]}]"
        >
          <a-select-option
            v-for="(item,index) in classlist"
            :key="index"
            :value="item.id"
          >
            {{item.title}}
          </a-select-option>
        </a-select>
      </div>
      <div class="oper">
        <input
        type="text"
        placeholder="请输入关键字"
        v-model="key"
      >
      <button
        class="ban"
        @click="searchbtn"
      >搜索</button>
      </div>
    </div>
    <ul class="list">
      <a-empty
        class="empty"
        v-if="list.length==0"
        description="暂未加入班级"
      />
      <li
        v-else
        v-for="(item,index) in list"
        :key="index"
      >
        <p class="tit">{{item.title}}</p>
        <p class="cou">
          <img src="../../assets/mine/sub.png" alt="">
          课程：{{item.course.title}}
        </p>
        <p class="stu">
           <img src="../../assets/mine/num.png" alt="">
          学生：<span>{{item.studentNum}}人</span>
        </p>
        <p
            class="view"
            @click="todetail(item.id)"
          >查看详情
        </p>
      </li>
      
      
    </ul>
    <div class="pagemodel">
      <pagination
        :pagination="pagination"
        @changePage="changePage"
      ></pagination>
    </div>
  </div>
</template>

<script>
import { getmyclassApi, getmyCourseListApi } from "@/request/api";
import pagination from "@/components/common/pagination";
export default {
  name: "myClass",
  components: { pagination },
  data() {
    return {
      classlist: "",
      searchInfo: {
        page: 1,
        pageSize: 9,
        keyword: null,
        courseId: null,
      },
      pagination: { total: "", pageSize: 9 },
      list: [],
      key: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getToken(getmyclassApi, this.searchInfo, (res) => {
        this.pagination.total = res.data.count;
        this.list = res.data.rows;
      });
      this.getToken(getmyCourseListApi, {}, (res) => {
        this.classlist = res.data;
        //  console.log(this.classlist)
      });
    },
    //下拉筛选
    Select(data) {
      // console.log(data)
      this.searchInfo.courseId = data;
      this.init();
    },
    //分页
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.init();
    },
    //查看
    todetail(id) {
      this.$router.push({ path: "/mystudent", query: { id } });
    },
    searchbtn() {
      this.searchInfo.keyword = this.key;
      this.init();
    },
  },
};
</script>
<style>
.empty {
  margin: 0 auto;
  margin-top: 30px;
}
.ant-select-selection{
    height: 35px;
    border-radius: 0px;
    border: solid 1px #d4d4d4;
}
</style>
<style lang="stylus" scoped>
.myClass {
  margin-bottom: 100px;
  .title {
      height: 45px;
      line-height: 45px;
      overflow: hidden;
      border-bottom:1px solid #eff2f2;
      h2 {
        height:45px;
        line-height: 45px;
        margin-left: 30px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
  }

  .sea {
    height: 45px;
    margin-left: 30px;
    margin-top: 20px;
    margin-right:30px;
    margin-bottom: 20px;
    display: flex;
    justify-content space-between
    align-items: center;

    span {
      color: #333;
      font-size: 16px;
      margin-right: 50px;
    }

    .mod {
      width: 204px;
      margin-right: 24px;
      margin-left: 280px;

      .selbtn {
        width: 100%;
        height: 100%;
      }
    }

    .oper{
      input {
      outline: none;
      width: 220px;
      height: 35px;
      border: solid 1px #d4d4d4;
      text-indent: 8px;
    }

    .ban {
      outline: none;
      width: 60px;
      height: 35px;
      background-color: #f1ce48;
      color: #333;
      font-size:14px;
      cursor: pointer;
      border:0
    }
    }
  }

  .list {
    display: flex;
    margin-top: 50px;
    margin-left: 30px;
    flex-wrap: wrap;

    li {
      border: 1px solid #ddd;
      width: 287px;
      margin-right: 35px;
      margin-bottom: 35px;
      color: #333;
      font-size: 16px;
      position: relative;
      .tit{
        color: #333333;
        width:100%;
        font-size:16px;
        margin-top:22px;
        margin-bottom:18px;
        font-weight:bolder;
        padding-left:17px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .cou{
          padding-left:17px;
          color: #666666;
          font-size:14px;
          margin-bottom:9px;
          height:25px;
          line-height 25px;
          overflow: hidden;
          width:100%;
          text-overflow: ellipsis;
          white-space: nowrap;
          img{
            width:20px;
            hegith:20px;
            margin-top:-3px;
            margin-right:11px;
          }
      }
      .stu{
         padding-left:17px;
         color: #666666;
         font-size:14px;
          height:25px;
          line-height 25px;
          margin-bottom:20px;
         img{
            width:20px;
            hegith:20px;
            margin-top:-3px;
            margin-right:11px;
          }
      }
      .view {
          color: #f1ce48;
          font-size:14px;
          cursor: pointer;
          height:35px;
          background-color: #fafafa;
          margin-bottom:0px;
          text-align center;
          line-height :35px;
        }

      &:nth-child(3n) {
        margin-right: 0px;
      }
    }
  }

  .pagemodel {
    margin-top: 30px;
    padding-top: 30px;
  }
}
</style>
